export enum EContractType {
  STANDARD = "STANDARD",
  ALPA = "ALPA",
  RMA = "RMA",
}

export enum EContractTypeLabel {
  STANDARD = "Standard Private Sale",
  ALPA = "ALPA Private Sale",
  RMA = "RMA Private Sale",
}

export enum EContractParty {
  BUYER = "buyer",
  VENDOR = "vendor",
}

export const ECONTRACT_TYPES_WITH_SPECIAL_CONDITIONS = [
  EContractType.ALPA,
  EContractType.RMA,
] as const;

export const eContractFieldInfoText = {
  // Vendor
  vendorName: "Resolved via the Vendor's Business name",
  vendorAddress: "Resolved via the Vendor's Business > Address",
  vendorContact:
    "Resolved via the Vendor's Business > Email Recipients > Primary Contact",
  vendorTransitInsurance:
    "Resolved via the Vendor's Business > Finance & Accounting > Insurance",
  // Purchaser
  purchaserName: "Resolved via the Buyer's Business name",
  purchaserAddress: "Resolved via the Buyer's Business > Address",
  purchaserContact:
    "Resolved via the Buyer's Business > Email Recipients > Primary Contact",
  purchaserTransitInsurance:
    "Resolved via the Buyer's Business > Finance & Accounting > Insurance",
  // Sale
  saleDate: "Resolved via the Sale Date",
  deliveryDate: "Resolved via the Consignment's Carrier Charge Delivery Date",
  deliveryLocation: "Resolved via the Buyer's Address",
  // Lot
  lotQty: "Resolved via the Lot Quantity",
  lotHdDelivered: "Recorded when the Lot is delivered",
  lotDescription: "Resolved via the Lot's Age, Breed and Sex",
  lotPrice: "Resolved via the Lot's Price and Pricing Type",
  lotWeight: "Resolved via the Lot's Weight",
  lotMarks: "Resolved via the Marks on the Lot",
  lotNotes: "Resolved via the Notes on the Lot",
  // PICs
  vendorPicNo: "Resolved via the Vendor Property on the Consignment",
  purchaserPicNo: "Resolved via Buyer's Property set on the Lot",
  // Consignment
  nvdNo: "Resolved via the NVD number of the Consignment",
  brands: "Resolved via the Brands field on the Consignment filled on the NVD",
  // Agent
  agentAddress: "Resolved via the Agency's Physical Address in Agency Settings",
  agentInConjunctionWith:
    "Resolved via the Vendor's Business > Relationships > Outside Agent",
  // Commission / Interest
  commission:
    "Resolved via the Vendor's Business > Vendor Commissions, falling back to the Agency Settings default",
  interestRate:
    "Resolved via the Buyer's Debit Interest Rate Setting, falling back to the Agency Settings default",
  // ABN / GST
  vendorAbn: "Resolved via the Vendor's Business > Finance & Accounting",
  vendorGst: "Resolved via the Vendor's Business > Finance & Accounting",
  // Charges
  chargeDescription: "Resolved via the Sundry's description",
  chargeAmount: "Resolved via the Sundry's subtotal",
  chargeSupplierInvoice: "Resolved via the Sundry's External Ref/s",
};
